import { FC, useEffect } from 'react'
import { GetServerSideProps } from 'next'
import { useDispatch } from 'react-redux'
import { LayoutHeader } from '@/components/domains/layouts'
import { ListProductReviews } from '@/components/domains/list'
import { MODEL_TYPE } from '@/containers/models/base/modelize'
import { ProductNameDocument } from '@/graphql/generated/hooks'
import { ProductNameQuery, ProductNameQueryVariables } from '@/graphql/generated/operations'
import { doSetHeaderTitle } from '@/stores/reduxUI'
import * as utilApi from '@/utils/utilApi'
import { initializeApollo } from '@/utils/utilApolloClient'

interface Props {
  productId: string
  productName: string
}

const PageProductReviews: FC<Props> = ({ productId, productName }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(doSetHeaderTitle(`${productName} 상품 리뷰 목록`))
  }, [])

  return (
    <>
      <LayoutHeader />
      <ListProductReviews productId={productId} />
    </>
  )
}

export default PageProductReviews

export const getServerSideProps: GetServerSideProps = async (context) => {
  const _id = context?.query?.productId
  const productId = _id ? utilApi.encodeId(MODEL_TYPE.PRODUCT, _id as string) : ''

  const client = initializeApollo()
  const { data } = await client.query<ProductNameQuery, ProductNameQueryVariables>({
    query: ProductNameDocument,
    variables: {
      id: productId,
    },
  })

  return {
    props: {
      productId,
      productName: data.product?.name || '',
    },
  }
}
